export default __webpack_public_path__ + "static/media/mobile-payment.c388fcf6.svg";